import {useRouter} from 'next/router';
import type {FC} from 'react';
import {LOGIN, PROFILE_AC_EMAIL} from '../../config/constants/routes';
import {QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE} from '../../core/entities/login/constants';
import {useIsAppWebView} from '../hooks/useIsAppWebView';
import {getMailAuthLinkWithParamsHooks} from '../services/getMailAuthLinkWithParamsHooks';

export const RegistBox: FC<{
  text?: string;
  studentVerificationText?: string;
  isStudentVerificationRequired?: boolean;
}> = ({
  text = '続きを読むには会員登録が必要です',
  studentVerificationText = '続きを読むには大学認証の完了が必要です',
  isStudentVerificationRequired = false,
}) => {
  const isWebView = useIsAppWebView();
  const router = useRouter();
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});
  return (
    <div className="absolute w-full p-16 pc:w-2/3 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <div className="flex flex-col bg-white justify-center items-center p-16 rounded-16 shadow-modal gap-12">
        <p className="text-center text-black-1 text-base pc:whitespace-nowrap">
          {isStudentVerificationRequired ? studentVerificationText : text}
        </p>
        <div className="flex gap-12">
          {isStudentVerificationRequired ? (
            <button
              type="button"
              className="bg-gradient-to-r from-gradient-register-l to-gradient-register-r rounded-full px-16 py-8 text-base font-bold text-white cursor-pointer hover:opacity-60"
              onClick={async () => {
                if (isWebView) {
                  location.href = PROFILE_AC_EMAIL;
                } else {
                  await router.push(PROFILE_AC_EMAIL);
                }
              }}
            >
              大学認証を完了する
            </button>
          ) : (
            <>
              <button
                type="button"
                className="bg-gradient-to-r from-gradient-register-l to-gradient-register-r rounded-full px-16 py-8 text-base font-bold text-white cursor-pointer hover:opacity-60"
                onClick={() => {
                  location.href = mailAuthLink;
                }}
              >
                会員登録
              </button>
              <button
                type="button"
                className="bg-white outline outline-2 outline-primary rounded-full px-16 py-8 text-base font-bold text-primary cursor-pointer hover:opacity-60"
                onClick={async () => {
                  const path = `${LOGIN}?${QUERY_PARAMS_FOR_REDIRECT_FROM_LOGIN_PAGE}=${router.asPath}`;
                  if (isWebView) {
                    location.href = path;
                  } else {
                    await router.push(path);
                  }
                }}
              >
                ログイン
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
